// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ControlPanel-module__layout__3C7R0{display:flex;padding-top:9px}.ControlPanel-module__container__2gr4k{padding:24px;display:flex;justify-content:center;align-items:center;min-height:calc(100vh - 65px)}.ControlPanel-module__menuItem__8y88F{border-radius:8px;transition:all .2s ease;cursor:pointer}.ControlPanel-module__mainContent__3N66i{flex:1;overflow-y:auto}.ControlPanel-module__pageContent__2Ap-g{min-height:calc(100vh - 65px);padding:24px}", ""]);
// Exports
exports.locals = {
	"layout": "ControlPanel-module__layout__3C7R0",
	"container": "ControlPanel-module__container__2gr4k",
	"menuItem": "ControlPanel-module__menuItem__8y88F",
	"mainContent": "ControlPanel-module__mainContent__3N66i",
	"pageContent": "ControlPanel-module__pageContent__2Ap-g"
};
export default exports;
